var map = {
	"../menu-management/menu-management.module": [
		"./src/app/modules/menu-management/menu-management.module.ts",
		"menu-management-menu-management-module"
	],
	"../offers/offers.module": [
		"./src/app/modules/offers/offers.module.ts",
		"offers-offers-module"
	],
	"../orders/orders.module": [
		"./src/app/modules/orders/orders.module.ts",
		"default~modules-signup-signup-module~orders-orders-module~restaurant-profile-restaurant-profile-modu~f5fcb6c5",
		"common",
		"orders-orders-module"
	],
	"../plan/plan.module": [
		"./src/app/modules/plan/plan.module.ts",
		"plan-plan-module"
	],
	"../reports/reports.module": [
		"./src/app/modules/reports/reports.module.ts",
		"reports-reports-module"
	],
	"../restaurant-profile/restaurant-profile.module": [
		"./src/app/modules/restaurant-profile/restaurant-profile.module.ts",
		"default~modules-signup-signup-module~orders-orders-module~restaurant-profile-restaurant-profile-modu~f5fcb6c5",
		"common",
		"restaurant-profile-restaurant-profile-module"
	],
	"../setup/setup.module": [
		"./src/app/modules/setup/setup.module.ts",
		"setup-setup-module"
	],
	"../support/support.module": [
		"./src/app/modules/support/support.module.ts",
		"support-support-module"
	],
	"../themes/themes.module": [
		"./src/app/modules/themes/themes.module.ts",
		"themes-themes-module"
	],
	"./components/addons-item/addons-item.module": [
		"./src/app/modules/menu-management/components/addons-item/addons-item.module.ts",
		"components-addons-item-addons-item-module"
	],
	"./components/category-list/category-list.module": [
		"./src/app/modules/menu-management/components/category-list/category-list.module.ts",
		"components-category-list-category-list-module"
	],
	"./components/menu-items/menu-items.module": [
		"./src/app/modules/menu-management/components/menu-items/menu-items.module.ts",
		"components-menu-items-menu-items-module"
	],
	"./components/menu-operational-time/menu-operational-time.module": [
		"./src/app/modules/menu-management/components/menu-operational-time/menu-operational-time.module.ts",
		"common",
		"components-menu-operational-time-menu-operational-time-module"
	],
	"./modules/home/home.module": [
		"./src/app/modules/home/home.module.ts",
		"default~modules-home-home-module~src-app-modules-profile-profile-module",
		"common",
		"modules-home-home-module"
	],
	"./modules/login/login.module": [
		"./src/app/modules/login/login.module.ts",
		"modules-login-login-module"
	],
	"./modules/menu-management/components/menu-operational-time/menu-operational-time.module": [
		"./src/app/modules/menu-management/components/menu-operational-time/menu-operational-time.module.ts",
		"common",
		"components-menu-operational-time-menu-operational-time-module"
	],
	"./modules/signup/signup.module": [
		"./src/app/modules/signup/signup.module.ts",
		"default~modules-signup-signup-module~orders-orders-module~restaurant-profile-restaurant-profile-modu~f5fcb6c5",
		"common",
		"modules-signup-signup-module"
	],
	"./shared/modals/components/otp-password/otp-password.module": [
		"./src/app/shared/modals/components/otp-password/otp-password.module.ts",
		"shared-modals-components-otp-password-otp-password-module"
	],
	"src/app/modules/profile/profile.module": [
		"./src/app/modules/profile/profile.module.ts",
		"default~modules-signup-signup-module~orders-orders-module~restaurant-profile-restaurant-profile-modu~f5fcb6c5",
		"default~modules-home-home-module~src-app-modules-profile-profile-module",
		"common",
		"src-app-modules-profile-profile-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;